angular.module('bizFormly').controller('questionFreetextController', questionFreetextController);
angular.module('bizFormly').controller('questionController', questionController);
angular.module('bizFormly').controller('questionScaleController', questionScaleController);
angular.module('bizFormly').controller('questionYesNoController', questionYesNoController);

questionFreetextController.$inject = ["$rootScope", "$scope", "bizCoreService"];
questionController.$inject = ["$rootScope", "$scope", "bizCoreService"];
questionScaleController.$inject = ["$rootScope", "$scope", "bizCoreService"];
questionYesNoController.$inject = ["$rootScope", "$scope", "bizCoreService", "$timeout"];

function questionFreetextController($rootScope, $scope, bizCoreService) {
    var vm = this;
}

function questionController($rootScope, $scope, bizCoreService) {

    $scope.SetSelectedValues = function(){
    	$scope.model[$scope.options.key] = $scope.options.data.options.GetItemsByValue('selected', true).GetValues('Id').join();
    }

    $scope.GetOptionTranslation = function (option) {
        var cultureId = $rootScope.LoggedInUser.CultureId;
        var translation = option.NameTranslations.GetItemByValue('CultureId', cultureId);
        if (!translation) {
            translation = {
                ObjectId: option.id,
                CultureId: cultureId,
                Type: '',
                Value: ""
            };
        }
        return translation;
    }

}

function questionScaleController($rootScope, $scope, bizCoreService) {
    var field = $scope.fields.GetItemByValue("key", $scope.options.key);

    if (!field.data.options) {
    	field.data.options = [];
    }

    $scope.GetOptionTranslation = function (option) {
        var cultureId = $rootScope.LoggedInUser.CultureId;

        var translation = option.NameTranslations.GetItemByValue('CultureId', cultureId);
        if (!translation) {
            translation = {
                ObjectId: option.id,
                CultureId: cultureId,
                Type: '',
                Value: ""
            };
        }
        return translation;
    }
}

function questionYesNoController($rootScope, $scope, bizCoreService, $timeout) {
    var field = $scope.fields.GetItemByValue("key", $scope.options.key);

    if (!field.data.options) {
    	field.data.options = [];

    	field.data.options.push({
            FormFieldId: field.Id, Name: "", Value: 'false', NameTranslations: [{
                FieldKey: field.key,
                CultureId: 1,
                Type: 'option',
                Value: "Yes"
            }, {
                FieldKey: field.key,
                CultureId: 2,
                Type: 'option',
                Value: "Yes"
            }]
        });
    	field.data.options.push({
            FormFieldId: field.Id, Name: "", Value: 'false', NameTranslations: [{
                FieldKey: field.key,
                CultureId: 1,
                Type: 'option',
                Value: "No"
            }, {
                FieldKey: field.key,
                CultureId: 2,
                Type: 'option',
                Value: "No"
            }]
        });
    }
    $scope.GetOptionTranslation = function (option) {
        var cultureId = $rootScope.LoggedInUser.CultureId;

        var translation = option.NameTranslations.GetItemByValue('CultureId', cultureId);
        if (!translation) {
            translation = {
                ObjectId: option.id,
                CultureId: cultureId,
                Type: '',
                Value: ""
            };
        }
        return translation;
    }
}


var evt = document.createEvent("CustomEvent");
evt.initCustomEvent("FORMS_PLUGIN_QUESTIONS_INIT", true, true, { Key: "QUESTIONS" });
window.dispatchEvent(evt);